import { Box } from "@chakra-ui/react";
import { FC } from "react";

import {
  FeatureCard,
  FeatureGrid,
  PageCta,
  PageHero,
  PageSection,
  SectionHeading,
  usePageTitle,
} from "./components";

export const VoorWaterschappen: FC = () => {
  usePageTitle("BROSTAR voor Waterschappen");

  return (
    <Box>
      <PageHero
        title="BROSTAR voor Waterschappen"
        subtitle="Waterschappen beheren uitgebreide grondwatermeetnetwerken. BROSTAR biedt de tools om grote hoeveelheden meetdata efficiënt en correct aan de BRO aan te leveren."
      />

      <PageSection>
        <SectionHeading>Schaalbaar beheer van meetnetwerken</SectionHeading>
        Waterschappen hebben vaak uitgebreide grondwatermonitoringsnetwerken, met honderden of wel
        duizenden meetpunten. Het beheren van deze netwerken en het aanleveren van de bijbehorende
        data aan de BRO is dan zachtgezegd een uitdaging. BROSTAR is ontworpen met deze schaal in
        gedachten, en biedt functionaliteiten die het beheer van grote hoeveelheden meetdata
        eenvoudiger maken. Of het nu gaat om het registreren van nieuwe meetpunten, het bijhouden
        van wijzigingen in bestaande punten, of het aanleveren van tijdreeksen grondwaterstanden,
        BROSTAR helpt u om dit efficiënt en foutloos te doen. We denken graag mee over de beste
        manier om BROSTAR in te zetten binnen uw organisatie, zodat u zich kunt richten op uw
        kerntaken, terwijl wij zorgen voor een soepele aanlevering aan de BRO.
        <FeatureGrid>
          <FeatureCard title="In de praktijk: losse projecten">
            Voor waterschappen voeren we regelmatig losse projecten uit voor de eenmalige vulling
            van putten (GMW), meetnetten (GMN) en grondwaterstanden (GLD) in de BRO.
          </FeatureCard>
          <FeatureCard title="Peilbuizen en meetnetbeheer vanuit GIS">
            Kunstwerken en peilbuizen worden door hun ruimtelijke component vaak beheert in GIS
            systemen. Wanneer u deze gegevens al in GIS heeft, is het mogelijk om vanuit deze
            database een koppeling richting BROSTAR te realiseren.
          </FeatureCard>
          <FeatureCard title="Grondwaterstanden geautomatiseerd aanleveren">
            Het BROSTAR team werkt met verschillende waterschappen aan een oplossing voor het
            geautomatiseerd aanleveren van grondwaterstanden, zowel vanuit FEWS als Wiski. Doordat
            FEWS en Wiski in essentie hetzelfde werken is een kleine hoeveelheid configuratie
            voldoende om een werkende koppeling met BROSTAR te realiseren.
          </FeatureCard>
          <FeatureCard title="Eenvoudig in te zetten">
            Hoewel het mogelijk is een automatische koppeling te bouwen, is het altijd mogelijk om
            BROSTAR voor een deel van uw verantwoordelijkheden in te zetten. Zo kan het zijn dat uw
            leverancier niet in staat is correcties of verwijder berichten te sturen, met BROSTAR
            heeft u zelf altijd een laagdrempelige manier om dit soort berichten te versturen,
            zonder dat u hiervoor een koppeling hoeft te bouwen.
          </FeatureCard>
          <FeatureCard title="Eenvoudig te leren">
            BROSTAR heeft een beperkte set aan functionaliteiten, en hierdoor is het ook eenvoudig
            om te leren. Nieuwe medewerkers kunnen zonder veel moeite aan de slag, en na enkele
            keren de applicatie gebruikt te hebben zullen ze er al snel wegwijs in zijn. Daarnaast
            is onze servicedesk altijd beschikbaar om vragen te beantwoorden, en kunnen we ook
            trainingen verzorgen wanneer hier behoefte aan is.
          </FeatureCard>
          <FeatureCard title="Gedeelde oplossing, voor langdurige samenwerking">
            Meerdere organisaties geloven in BROSTAR, hierdoor is de levensduur van de applicatie
            gewaarborgd. We blijven continu doorontwikkelen, en staan altijd open voor feedback en
            suggesties.
          </FeatureCard>
        </FeatureGrid>
      </PageSection>

      <PageCta
        title="Efficiënt aanleveren als waterschap"
        body="Sluit u aan bij de waterschappen die BROSTAR gebruiken voor betrouwbare en schaalbare BRO-aanlevering."
      />
    </Box>
  );
};
